export const messageSuffixes = {
  required: ' is required'
};

export const errorMessage = {
  emailRequired: `Email ${messageSuffixes.required}`,
  passwordRequired: `Password ${messageSuffixes.required}`,
  loginError: 'Invalid Email and Password combination'
};
